/*
 * On-demand loader for Swiper and fancyBox (STR-1265).
 *
 * Both libraries used to load on every product page — 137 KB of Swiper, 67 KB
 * of fancyBox and a render-blocking swiper-bundle.css, all ahead of the product
 * image itself on a throttled connection. They are now fetched when they are
 * about to be needed: Swiper just before a slider scrolls into view, fancyBox
 * on the first lightbox click.
 *
 * jQuery is deliberately untouched — jquery-zoom.js needs it on the PDP.
 *
 * Asset URLs come from Liquid via data attributes on the script tag, since a
 * static asset cannot call asset_url itself.
 *
 * Usage from a section:
 *
 *   StraumLibs.slider(document.querySelector('.swiper-slider-x'), () => {
 *     new Swiper('.swiper-slider-x', { ... });
 *   });
 *
 *   StraumLibs.swiper().then(() => { ... });   // load now
 *   StraumLibs.fancybox().then(() => { ... }); // load now
 */
(function () {
  'use strict';

  var config = (document.currentScript && document.currentScript.dataset) || {};
  var pending = {};

  function loadCss(href) {
    if (!href) return;
    if (document.querySelector('link[href="' + href + '"]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function loadJs(src) {
    return new Promise(function (resolve, reject) {
      if (!src) {
        reject(new Error('lib-loader: missing script URL'));
        return;
      }

      // Another component may already have injected the same bundle.
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        existing.addEventListener('load', resolve);
        existing.addEventListener('error', reject);
        return;
      }

      var script = document.createElement('script');
      script.src = src;
      script.onload = resolve;
      script.onerror = function () {
        reject(new Error('lib-loader: failed to load ' + src));
      };
      document.head.appendChild(script);
    });
  }

  function load(name, cssHref, jsSrc, isReady) {
    if (isReady()) return Promise.resolve();
    if (!pending[name]) {
      loadCss(cssHref);
      pending[name] = loadJs(jsSrc).catch(function (error) {
        // Let a later call retry rather than caching the failure forever.
        pending[name] = null;
        throw error;
      });
    }
    return pending[name];
  }

  function swiperReady() {
    return typeof window.Swiper !== 'undefined';
  }

  function fancyboxReady() {
    return !!(window.jQuery && window.jQuery.fn && window.jQuery.fn.fancybox);
  }

  var StraumLibs = {
    swiper: function () {
      return load('swiper', config.swiperCss, config.swiperJs, swiperReady);
    },

    fancybox: function () {
      if (!window.jQuery) {
        return Promise.reject(new Error('lib-loader: fancyBox needs jQuery'));
      }
      return load('fancybox', config.fancyboxCss, config.fancyboxJs, fancyboxReady);
    },

    /* Load Swiper when `element` is about to enter the viewport, then run
       `init`. A slider that never scrolls into view never costs a byte. */
    slider: function (element, init) {
      if (!element || typeof init !== 'function') return;

      var start = function () {
        StraumLibs.swiper().then(init).catch(function () {});
      };

      if (!('IntersectionObserver' in window)) {
        start();
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (!entries[i].isIntersecting) continue;
            observer.disconnect();
            start();
            return;
          }
        },
        { rootMargin: '300px 0px' }
      );

      observer.observe(element);
    }
  };

  window.StraumLibs = StraumLibs;
})();
